import { render, staticRenderFns } from "./ehc-properties.vue?vue&type=template&id=23b73c26"
import script from "./ehc-properties.vue?vue&type=script&lang=js"
export * from "./ehc-properties.vue?vue&type=script&lang=js"
import style0 from "./ehc-properties.vue?vue&type=style&index=0&id=23b73c26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports